var _path, _path2, _path3, _polygon, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarsDm(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.4595,
    height: 100,
    viewBox: "0 0 94.4595 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5107,37.2217v61.059c0,.9495,.7698,1.7193,1.7193,1.7193s1.7193-.7698,1.7193-1.7193V37.2221l-1.7195-.904-1.719,.9037Z",
    fill: "#e9e9e9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7433,56.7329l-1.5827,.3871-.4568,1.2031c4.6851,5.0195,8.3993,10.081,11.2902,15.3971,7.309,13.4402,8.3491,24.5588,8.3592,24.6696,.0579,.6712,.6212,1.1778,1.2827,1.1778,.0378,0,.0747-.0017,.1125-.005,.7094-.0613,1.2349-.685,1.1736-1.394-.0403-.4726-1.0787-11.7348-8.6627-25.6808-2.9634-5.4497-6.7547-10.6304-11.5159-15.755Z",
    fill: "#e9e9e9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7161,56.7328c-4.7606,5.1243-8.5515,10.305-11.5153,15.755-7.5839,13.946-8.6224,25.2081-8.6627,25.6808-.0613,.7094,.4651,1.3339,1.1744,1.3948,.0369,.0029,.0747,.0046,.1117,.0046,.6624,0,1.2257-.5075,1.2827-1.1795,.0101-.1104,1.0309-11.1925,8.3588-24.6683,2.8916-5.3164,6.6056-10.3781,11.2901-15.3972l-.4568-1.203-1.5829-.3872Z",
    fill: "#e9e9e9"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "34.14 40.2861 47.2297 33.4044 60.3195 40.2861 57.8196 25.7105 68.4094 15.3879 53.7747 13.2613 47.2297 0 40.6849 13.2613 26.0501 15.3879 36.6399 25.7105 34.14 40.2861",
    fill: "#e9e9e9"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "20.0924 46.5575 20.8122 36.8865 12.6982 42.1977 3.7229 38.5246 6.2668 47.8828 0 55.2836 9.6863 55.7561 14.7884 64.0032 17.7256 56.2677 18.2309 54.937 19.6826 54.582 27.651 52.6332 20.0924 46.5575",
    fill: "#e9e9e9"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.1927 47.8828 90.7366 38.5246 81.7613 42.1977 73.6473 36.8865 74.3672 46.5575 66.8085 52.6332 74.7767 54.5819 76.2286 54.937 76.7338 56.2675 79.6712 64.0032 84.7733 55.7561 94.4595 55.2836 88.1927 47.8828",
    fill: "#e9e9e9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsDm);
export default __webpack_public_path__ + "static/media/stars_dm.ecb20ec2ddfb8b986f244f9c11106974.svg";
export { ForwardRef as ReactComponent };